import React from "react";
import Row from "react-bootstrap/Row";
import { Subscribe } from "unstated";

import { myGlobals, myUtilities } from "../../Utils";
import PaymentDataContainer from "../../Stores/PaymentDataContainerStore";
import InvoiceDataContainer from "../../Stores/InvoiceDataContainerStore";

import { PayButton, PaymentElements } from "./";

class SepaPaymentForm extends React.Component {
  handleSubmit = (event, invData, payData) => {
    event.preventDefault();
    myGlobals.handleACHFormSubmit(invData, payData);
  };
  render() {
    return (
      <Subscribe to={[PaymentDataContainer]}>
        {(data) => (
          <Subscribe to={[InvoiceDataContainer]}>
            {(invData) => (
              <div className="sepa-form center-element">
                <div className="sepa-top-margin centered" />
                <form
                  onSubmit={(event) => {
                    this.handleSubmit(event, invData, data);
                  }}
                >
                  <Row>
                    <PaymentElements
                      EUR
                      name={"bankAccNo"}
                      header={
                        <div>
                            {myUtilities.accountSpecificLanguage(
                              "Sepa.Form.Header.iban",
                              "IBAN Number")}
                            <span className="red-asterisk">*</span>
                        </div>
                      }
                    />
                  </Row>

                  <Row>
                    <PaymentElements
                      EUR
                      name={"accountName"}
                      header={
                        <div>
                            {myUtilities.accountSpecificLanguage(
                              "Sepa.Form.Header.accountname",
                              "Account Holder's Name")}
                            <span className="red-asterisk">*</span>
                        </div>
                      }
                    />
                  </Row>
                    {typeof myGlobals.PPRO_TNC_INFO.SEPA_ACH !== "undefined" &&
                        myGlobals.PPRO_TNC_INFO.SEPA_ACH !== "" && (
                          <div class="privacy-hyperlink-div">
                            <a
                              target="_blank"
                              class="privacy-hyperlink"
                              href={myGlobals.PPRO_TNC_INFO.SEPA_ACH}
                            >
                              {myUtilities.accountSpecificLanguage(
                                "OnlinePaymentMethods.PrivacyLink",
                                "Click here to read the privacy policy")}
                            </a>
                          </div>
                        )}

                  <div className="adjust-top-margin" />
                  <Row>
                    <PayButton />
                  </Row>
                </form>
              </div>
            )}
          </Subscribe>
        )}
      </Subscribe>
    );
  }
}

export default SepaPaymentForm;
